import React from 'react'
import styles from '../dropdown.module.scss'
import Typography from '../../Typography'
import clsx from 'clsx'

const LabelWrapper = ({ startIcon, endIcon, children }) => (
  <span
    className={clsx('label-wrapper', {
      [styles[`label-withStartIcon`]]: !!startIcon && children,
      [styles[`label-withEndIcon`]]: !!endIcon && children,
    })}
  >
    {children}
  </span>
)

const DropdownItem = ({
  startIcon = null,
  endIcon = null,
  children,
  className,
  noHover,
  component = null,
  variant = 'p7',
  ...rest
}) => {
  return (
    <Typography
      component={component || 'div'}
      variant={variant}
      className={clsx(
        'dropdown-item',
        styles.item,
        {
          [styles['no-hover']]: noHover,
        },
        className,
      )}
      noMargin
      {...rest}
    >
      {startIcon}
      {startIcon || endIcon ? (
        <LabelWrapper startIcon={startIcon} endIcon={endIcon}>
          {children}
        </LabelWrapper>
      ) : (
        children
      )}
      {endIcon}
    </Typography>
  )
}

export default DropdownItem
